import * as yup from 'yup';

import { CreditCardValidationSchema } from '@vizsla/stripe';
import { BillingAddressValidationSchema } from '@vizsla/constants';

export const FundraiserDonationFormSchema = yup.object({
  creditCard: CreditCardValidationSchema,
  billingAddress: BillingAddressValidationSchema,
});
